import { useTranslation } from "react-i18next";

interface OfflineMessageProps {
  visible: boolean;
}

export function OfflineMessage({ visible }: OfflineMessageProps) {
  const { t } = useTranslation();

  if (!visible) return null;

  return (
    <p className="text-xs text-muted-foreground pt-1 leading-relaxed">
      {t("offlineStatus.offlineMessage")}
    </p>
  );
}
